// Moved verbatim out of the original single-file App.tsx. Markup and classes are
// unchanged — the meeting tool is live and this restructure must not alter it.

import { Empty } from './Card';

export type TodoStatus = 'open' | 'done' | 'aside';
export type TodoItem = { text: string; owner?: string | null };

export function TodoList({
  listType,
  items,
  states,
  onChange,
  empty,
}: {
  listType: string;
  items: TodoItem[];
  states: Record<string, TodoStatus>;
  onChange: (key: string, status: TodoStatus) => void;
  empty: string;
}) {
  if (items.length === 0) return <Empty text={empty} />;
  return (
    <ul className="space-y-1.5">
      {items.map((it) => {
        const key = `${listType}::${it.text}`;
        return (
          <TodoRow
            key={key}
            itemKey={key}
            text={it.text}
            owner={it.owner ?? null}
            status={states[key] ?? 'open'}
            onChange={onChange}
          />
        );
      })}
    </ul>
  );
}

function TodoRow({
  itemKey,
  text,
  owner,
  status,
  onChange,
}: {
  itemKey: string;
  text: string;
  owner: string | null;
  status: TodoStatus;
  onChange: (key: string, status: TodoStatus) => void;
}) {
  const done = status === 'done';
  const aside = status === 'aside';
  return (
    <li className={`group flex items-start gap-2.5 rounded-md px-1.5 py-1 text-sm transition ${aside ? 'opacity-45' : 'text-[#273142] hover:bg-white/[0.02]'}`}>
      <button
        type="button"
        onClick={() => onChange(itemKey, done ? 'open' : 'done')}
        disabled={aside}
        aria-label={done ? 'Mark not done' : 'Mark done'}
        aria-pressed={done}
        className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded border font-mono text-[0.6rem] transition ${
          done ? 'border-cyan bg-cyan/20 text-cyan' : 'border-edge text-transparent hover:border-cyan'
        } ${aside ? 'cursor-not-allowed' : ''}`}
      >
        ✓
      </button>
      <span className={`flex-1 ${done ? 'text-[#7a8493] line-through' : ''}`}>
        {text}
        {owner && (
          <span className="ml-2 rounded bg-cyan/10 px-1.5 py-0.5 font-mono text-[0.7rem] text-cyan">
            {owner}
          </span>
        )}
        {aside && (
          <span className="ml-2 font-mono text-[0.6rem] uppercase tracking-wider text-[#7a8493]">
            parked
          </span>
        )}
      </span>
      <button
        type="button"
        onClick={() => onChange(itemKey, aside ? 'open' : 'aside')}
        className="shrink-0 font-mono text-[0.6rem] uppercase tracking-wider text-[#8b94a3] opacity-0 transition hover:text-cyan group-hover:opacity-100"
      >
        {aside ? 'Restore' : 'Set aside'}
      </button>
    </li>
  );
}
